import { render, staticRenderFns } from "./DeliveryTime.vue?vue&type=template&id=24c94512&scoped=true"
import script from "./DeliveryTime.vue?vue&type=script&lang=js"
export * from "./DeliveryTime.vue?vue&type=script&lang=js"
import style0 from "./DeliveryTime.vue?vue&type=style&index=0&id=24c94512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c94512",
  null
  
)

export default component.exports